import * as actionTypes from './actionTypes';
import axios from '../../utilities/interceptor';
import { getMessage } from '../../utilities/getMessage';


export const getOneMember=(id)=>async dispatch=>{
    dispatch({
        type:actionTypes.GET_ONE_MEMBER_START
    })
    await axios.get(`/members/${id}`)
            .then(response=>dispatch({
                type:actionTypes.GET_ONE_MEMBER_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.GET_ONE_MEMBER_FAIL,
                payload:getMessage(error)
            }))
}